<div class="header">
  <h2>Add Risers</h2>
</div>
<div class="content">
  <div class="filterContainer">
    <input class="filterInput" [disabled]="isBusy()" (keyup)="filterList()" [(ngModel)]="copperFilter"
      placeholder="Copper Type"/>
    <input class="filterInput" [disabled]="isBusy()" (keyup)="filterList()" [(ngModel)]="diameterFilter"
      placeholder="Diameter"/>
    <input class="filterInput" [disabled]="isBusy()" (keyup)="filterList()" [(ngModel)]="insulationFilter"
      placeholder="Insulation"/>
    <label for="riserOnlyInput">Risers Only</label>
    <input class="checkboxInput" id="riserOnlyInput" type="checkbox" [disabled]="isBusy()" (change)="filterList()"
      [(ngModel)]="risersOnly"/>
  </div>
  <div class="resultContainer">
    <table class="reportTable">
      @if (filtered() && filtered().length > 0) {
        @for (riser of filtered(); track riser) {
          <tr class="selectableRow" (click)="selectRiser(riser)">
            <td class="tableCell">{{ riser.description }}</td>
          </tr>
        }
      }
      @if (!filtered() || filtered().length === 0) {
        <tr>
          <td>No results match your search</td>
        </tr>
      }
    </table>
  </div>
  <div class="selectionsContainer">
    <table class="selectionTable reportTable">
      @if (selectedRisers().length > 0) {
        @for (riser of selectedRisers(); track riser) {
          <tr>
            <td class="tableCell deleteCell">
              <button matButton="text" class="deleteButton warn-button" (click)="removeSelection(riser)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
            <td class="tableCell descriptionCell">{{ riser.description }}</td>
            <td class="tableCell quantityCell"><input class="quantityInput" [(ngModel)]="riser.quantity"
            placeholder="Quantity"/></td>
          </tr>
        }
      }
      @if (selectedRisers().length === 0) {
        <tr>
          <td colspan="3">Nothing selected</td>
        </tr>
      }
    </table>
  </div>
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
<div mat-dialog-actions>
  <span class="spacer"></span>
  <span>
    <button class="warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
    <button class="primary-button" matButton="elevated" [disabled]="selectedRisers().length === 0"
    (click)="saveAndClose()">Save</button>
  </span>
</div>

